export default "__VITE_ASSET__DTdPqeUZ__"